// extracted by mini-css-extract-plugin
export default {"bubble":"JMISu","icon":"vG5UP","container":"Of6Oj","skeleton-progress":"t0z5J"};